import { Routes, Route } from 'react-router-dom'
import LoginPage from './pages/Login'
import RegisterPage from './pages/Register'
import ConsentPage from './pages/Consent'
import ErrorPage from './pages/Error'
import HomePage from './pages/Home'
import LogoutPage from './pages/Logout'
import { AuthFlowPage } from './components/AuthFlowPage'
import { AuthBackground } from './components/AuthBackground'

function App() {
  return (
    <div className="auth-app">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/consent" element={<ConsentPage />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/recovery" element={<AuthFlowPage key="recovery" kind="recovery" />} />
        <Route path="/verification" element={<AuthFlowPage key="verification" kind="verification" />} />
        <Route path="/settings" element={<AuthFlowPage key="settings" kind="settings" />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      <AuthBackground />
    </div>
  )
}

export default App
